import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { sanitizedCategories } from "@antoine-lb/business-logic"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ParentCategoryButton from "../components/parentCategoryButton"
import ChooseLocation from "../components/chooseLocation"

import styled from "styled-components"

const WelcomeText = styled.div`
  padding: 15px 0;
  padding-right: 10px;

  p {
    margin: 5px 0;
  }
`

const IndexPage = ({ data }) => {
  const sanitizedCat = sanitizedCategories(
    data.allStrapiProductCategory.edges.map(obj => obj.node)
  )
  return (
    <Layout>
      <SEO title="Home" />
      <h1 style={{textAlign:"center"}}>Bienvenidos</h1>
      <svg
                style={{marginLeft:"10%"}}
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="80%"
                /* height="50px" */
                viewBox="0 0 226.772 113.387"
                enableBackground="new 0 0 226.772 113.387"
                // xml:space="preserve"
              >
                <g>
                  <g>
                    <path
                      fill="#732619"
                      d="M47.74,55.44c0.271-2.053,0.337-4.128,0.571-6.186c0.058-0.507,0.279-1.054,0.587-1.472
			c1.185-1.613,2.465-3.159,3.654-4.768c2.153-2.916,2.86-6.121,1.869-9.561c-1.277-4.434-4.944-6.511-9.476-6.389
			c-5.516,0.15-10.874,1.284-15.049,5.011c-0.474,0.423-0.776,0.883-0.83,1.334c-0.118,0.985,0.065,1.916,0.381,2.786
			c0.953,2.636,1.935,5.272,3.088,7.829c5.801,12.868,12.095,25.514,18.522,38.098c0.256,0.501,0.523,0.642,1.098,0.581
			c3.808-0.4,7.409-1.431,10.725-3.309c3.034-1.717,5.413-4.032,6.659-7.253c1.4-3.618,1.146-7.247-0.087-10.816
			c-0.908-2.624-2.548-4.739-5.247-5.897c-3.628-1.555-7.46-1.546-11.275-0.865c-1.731,0.309-3.481,0.74-5.223,1.219 M45.81,16.044
			c1.648,0.021,3.226,0.19,4.799,0.479c5.839,1.07,10.867,3.529,14.564,8.12c1.71,2.122,2.934,4.523,3.196,7.19
			c0.261,2.652-0.57,4.629-1.837,6.687c-2.161,3.509-5.118,6.365-8.237,9.081c-0.672,0.585-1.369,1.145-2.029,1.695
			c2.133-0.345,4.253-0.792,6.396-1.014c4.504-0.465,8.96-0.285,13.255,1.247c5.377,1.922,8.883,5.559,10.27,10.871
			c0.513,1.971,0.448,4.115,0.429,6.184c-0.047,4.706-1.355,9.096-4.071,13.075c-2.457,3.598-5.768,6.333-9.485,8.658
			c-4.629,2.895-9.686,4.959-14.712,7.084c-3.667,1.55-7.444,2.889-10.948,4.769c-1.6,0.857-2.294,1.289-3.775,2.278
			c-0.344,0.229-0.833,0.61-1.092,0.805c-0.169,0.127-0.512,0.393-0.522,0.373c-0.067-0.136-0.111-0.291-0.146-0.389
			c-1.771-5.206-3.379-10.452-5.349-15.583c-2.769-7.222-5.691-14.389-8.762-21.492c-3.762-8.699-8.087-17.147-13.383-25.081
			c-2.28-3.416-5.007-6.69-7.49-9.981c-0.006-0.055,0.389-0.432,0.389-0.432s1.161-1.18,2.208-2.015
			c1.573-1.256,3.27-2.5,5.047-3.465c4.838-2.627,9.919-4.74,15.217-6.343c1.948-0.589,3.881-1.2,5.886-1.642
			C38.916,16.479,42.314,16.058,45.81,16.044"
                    />
                    <path
                      fill="#732619"
                      d="M115.897,41.17c-0.446-2.872-0.934-5.097-2.253-7.062c-1.248-1.861-3.355-2.506-5.544-1.815
			c-2.265,0.715-3.764,2.219-4.903,4.124c-1.897,3.174-2.934,6.677-3.424,10.241c-0.338,2.47-0.342,4.92,0.531,7.337
			c1.343,3.716,4.211,4.934,7.962,4.002c4-0.994,6.207-3.737,7.327-7.363C116.622,47.307,116.117,43.929,115.897,41.17
			 M129.871,28.896c-0.235,0.458-3.925,10.711-3.886,19.586c0.038,8.153,3.792,14.999,3.854,15.201
			c0.175,0.56,0.105,0.729-0.504,0.989c-4.061,1.719-8.085,3.519-12.124,5.291c-0.69,0.306-1.381,0.614-2.086,0.928
			c-0.61-1.435-1.189-2.8-1.797-4.236c-2.024,1.427-4.144,2.329-6.398,2.939c-6.214,1.68-11.332-0.14-14.658-5.432
			c-5.548-8.83-5.577-17.907-0.53-27.068c2.748-4.988,6.835-8.583,12.413-10.534c2.497-0.872,5.003-0.863,7.542-0.353
			c1.66,0.333,3.72,0.934,5.327,1.493c0,0,0.455-0.925,0.748-1.436c0,0,0.968,0.229,1.409,0.352
			C122.661,27.584,126.245,28.115,129.871,28.896"
                    />
                    <path
                      fill="#732619"
                      d="M200.498,53.029c1.071-2.768,1.129-5.198,1.122-5.553c-0.004-0.38-0.051-0.76-0.082-1.138
			c-0.292-3.72-1.437-7.159-3.73-10.212c-2.471-3.283-5.644-4.053-9.125-2.203c-1.316,0.7-2.372,1.7-3.138,2.929
			c-2.969,4.777-3.252,9.813-1.252,14.984c1.509,3.898,4.625,5.869,8.933,5.568c3.159-0.22,6.003-1.352,7.286-4.355 M213.911,50.511
			c0.041,5.587-2.494,10.051-7.053,13.443c-3.081,2.292-6.678,3.383-10.499,3.904c-3.903,0.534-7.749,0.412-11.505-0.904
			c-5.562-1.954-9.216-5.764-11.568-10.856c-1.532-3.321-2.141-6.796-1.645-10.381c1.024-7.4,4.333-13.477,11.341-17.241
			c2.639-1.418,5.549-2.003,8.583-2.014c6.975-0.024,12.599,2.762,17.066,7.774c3.054,3.425,4.598,7.519,5.044,11.958
			C213.839,47.827,213.895,48.885,213.911,50.511"
                    />
                    <path
                      fill="#732619"
                      d="M156.581,52.274c3.521-0.856,7.053-1.714,10.539-2.562c0.628,3.771-1.246,6.947-4.16,9.071
			c-4.896,3.568-9.684,5.405-16.411,5.864c-4.478,0.306-8.436-1.478-10.832-5.157c-2.041-3.134-2.808-6.629-3-10.275
			c-0.218-4.254,0.512-8.367,1.956-12.353c1.812-5,4.716-9.272,9.317-12.349c3.32-2.219,7.023-3.41,11.044-3.627
			c1.664-0.09,3.377-0.125,5.01,0.147c2.375,0.396,4.156,1.952,5.544,3.712c2.102,2.661,3.495,5.34,4.184,8.617
			c0.11,0.525,0.206,1.345,0.255,1.896c-4.876,0.392-9.353,1.86-13.929,3.238c-0.216-1.458-0.323-2.863-0.649-4.221
			c-0.304-1.26-0.743-2.512-1.295-3.692c-1.154-2.468-4.036-1.931-5.367-0.709c-1.077,0.987-1.762,2.215-2.113,3.575
			c-1.507,5.865-1.513,11.697,0.71,17.435c0.638,1.649,1.51,3.173,2.92,4.369c0.864,0.732,1.847,1.174,2.987,1.267
			c1.567,0.127,2.584-0.685,2.953-2.342C156.375,53.591,156.455,52.996,156.581,52.274"
                    />
                  </g>
                </g>
              </svg>

      {/* <Img
        style={{
          height: "300px",
          boxShadow:
            "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
        }}
        fluid={data.placeholderImage.childImageSharp.fluid}
      /> */}

      <WelcomeText>
        <div style={{fontSize:"1.2em"}}>
          <p style={{fontSize:"1.5em", textAlign : "center"}}>
            Nuestros <strong>horarios de despacho</strong> son
          </p>
          <p style={{ textAlign:"center" ,marginLeft: "10px" }}>
            Lunes a Miércoles de <strong>10:30h a 20:30h.</strong>
          </p>
          <p style={{ textAlign:"center", marginLeft: "10px" }}>
            Jueves a Sábado de <strong>10:30h a 21:30h.</strong>
          </p>
          <p style={{ textAlign:"center", marginLeft: "10px" }}>
            Domingos de <strong>10:30h a 19:30h.</strong>
          </p>
        </div>
      </WelcomeText>
      <ChooseLocation />
      {/* <h1>Carta</h1> */}
      <br/>
      <div>
        {sanitizedCat.map(parentCategory => {
          return (
            <ParentCategoryButton
              unicTitle={parentCategory.title}
              slug={parentCategory.slug}
              key={parentCategory.slug}
            />
          )
        })}
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query MyQuery {
    placeholderImage: file(relativePath: { eq: "baco-landing.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    allStrapiProductCategory {
      edges {
        node {
          title
          slug
          priority
          product_priorities
          default_open
          parent_category {
            title
            slug
            priority
            product_priorities
          }
          child_categories {
            title
            slug
            priority
            product_priorities
          }
          products {
            name
            price_in_cent
            description
            product_id
            visible
            thumbnail {
              childImageSharp {
                fluid(traceSVG: { background: "#73261988", color: "#732619" }) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`

export default IndexPage
